import React from 'react';
import { Box, Paper, Typography, Link } from '@mui/material';
import { Email as EmailIcon, Language as LanguageIcon } from '@mui/icons-material';
import AppStyles from '../styles/AppStyles';
import { useTranslation } from 'react-i18next';

export default function About() {
  const { t } = useTranslation();

  const handleEmailClick = () => {
    window.location.href = 'mailto:contact@pawwi.ro';
  };

  const handleWebsiteClick = () => {
    window.open('https://www.pawwi.ro', '_blank');
  };

  const handleTermsClick = () => {
    window.open('https://pawwi.ro/terms', '_blank');
  };

  const handlePrivacyClick = () => {
    window.open('https://pawwi.ro/privacy', '_blank');
  };

  const Section = ({ title, children }) => (
    <Paper
      sx={{
        p: 3,
        mb: 3,
        borderRadius: 3,
        background: 'transparent',
        border: `1px solid ${AppStyles.colors.border.light}`,
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '4px',
          background: `linear-gradient(90deg, ${AppStyles.colors.primary.main} 0%, ${AppStyles.colors.secondary.main} 100%)`,
        }
      }}
    >
      <Typography 
        variant="h6" 
        sx={{ 
          color: AppStyles.colors.primary.dark, 
          fontWeight: AppStyles.typography.fontWeight.semibold, 
          mb: 2 
        }}
      >
        {title}
      </Typography>
      {children}
    </Paper>
  );

  const ContactItem = ({ icon, label, value, onClick, isLink = false }) => (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
      {icon}
      <Box sx={{ flex: 1 }}>
        <Typography 
          variant="overline" 
          sx={{ 
            color: AppStyles.colors.text.secondary,
            display: 'block',
            mb: 0.5
          }}
        >
          {label}
        </Typography>
        {isLink ? (
          <Link
            href={onClick ? undefined : value}
            onClick={onClick}
            underline="hover"
            sx={{
              color: AppStyles.colors.primary.main,
              fontWeight: AppStyles.typography.fontWeight.medium,
              cursor: 'pointer',
            }}
          >
            {value}
          </Link>
        ) : (
          <Typography 
            variant="body1" 
            sx={{ 
              color: AppStyles.colors.text.primary, 
              fontWeight: AppStyles.typography.fontWeight.medium 
            }}
          >
            {value}
          </Typography>
        )}
      </Box>
    </Box>
  );

  const LegalItem = ({ text, onClick }) => (
    <Box
      sx={{
        py: 1.5,
        borderBottom: `1px solid ${AppStyles.colors.border.light}`,
        '&:last-child': {
          borderBottom: 'none',
        },
      }}
    >
      <Link
        onClick={onClick}
        underline="hover"
        sx={{
          color: AppStyles.colors.action || AppStyles.colors.primary.main,
          fontWeight: AppStyles.typography.fontWeight.medium,
          cursor: 'pointer',
          fontSize: AppStyles.sizes.fontMedium || '1rem',
        }}
      >
        {text}
      </Link>
    </Box>
  );

  return (
    <Box sx={{ p: 2 }}>
      {/* Contact Section */}
      <Section title={t('about.contact', 'Contact')}>
        <ContactItem
          icon={<EmailIcon sx={{ fontSize: 20, color: AppStyles.colors.primary.main }} />}
          label={t('about.email', 'Email')}
          value="contact@pawwi.ro"
          onClick={handleEmailClick}
          isLink={true}
        />
        <ContactItem
          icon={<LanguageIcon sx={{ fontSize: 20, color: AppStyles.colors.primary.main }} />}
          label={t('about.website', 'Website')}
          value="www.pawwi.ro"
          onClick={handleWebsiteClick}
          isLink={true}
        />
      </Section>

      {/* Legal Section */}
      <Section title={t('about.legal', 'Legal')}>
        <LegalItem
          text={t('about.termsAndConditions', 'Terms & Conditions')}
          onClick={handleTermsClick}
        />
        <LegalItem
          text={t('about.privacyPolicy', 'Privacy Policy')}
          onClick={handlePrivacyClick}
        />
      </Section>
    </Box>
  );
}

